import { BrowserModule } from '@angular/platform-browser';
import { NgModule, ErrorHandler } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';

import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { HttpRequestInterceptor } from './services/http-interceptor';
import { ErrorsHandlerService } from './services/errors-handler.service';

// import { AuthGuard } from './pages/auth/auth.guard';
import { UtilityFunctions } from './utilities/utility-func';
import { EncDecData } from './utilities/enc.dec';
import { AuthService } from './pages/auth/auth.service';
import { AuthGuard } from './pages/auth/auth.guard';

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    ReactiveFormsModule,
    FormsModule,
    BrowserAnimationsModule,
    AppRoutingModule,
  ],
  providers: [
    { provide: ErrorHandler, useClass: ErrorsHandlerService },
    { provide: HTTP_INTERCEPTORS, useClass: HttpRequestInterceptor, multi: true },
    {
      provide: LocationStrategy,
      useClass: HashLocationStrategy,
    }, UtilityFunctions, EncDecData,
    AuthGuard, AuthService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
